<ion-content>
  <div class="absolute right-4 top-4" (click)="location.back()">
    <ion-icon class="text-[42px]" name="close-outline"></ion-icon>
  </div>
  <div class="flex flex-col justify-center h-full">
    <div class="relative bg-white rounded-2xl px-6 pt-16 pb-4 shadow m-3">
      <img
        class="absolute top-0 h-[114px] left-[50%] -translate-x-1/2 -translate-y-3/4"
        style="filter: drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.25))"
        src="/assets/logos/logo.svg"
      />
      <form [formGroup]="forgotForm" novalidate class="flex flex-col gap-6">
        <h2 class="text-center">{{ 'ONBOARDING.FORGOT_PASSWORD.TITLE' | transloco }}</h2>
        <p>{{ 'ONBOARDING.FORGOT_PASSWORD.HINT' | transloco }}</p>
        <ion-input
          fill="solid"
          labelPlacement="floating"
          formControlName="email"
          type="email"
          required
          inputmode="email"
          [label]="'ONBOARDING.FORGOT_PASSWORD.EMAIL' | transloco "
        />
        <!-- Error messages -->
        <span
          class="input-error ion-padding"
          class="ion-invisible"
          [hidden]="isForgotSubmitted && forgotForm.controls.email.errors"
          >&nbsp;</span
        >
        <span
          class="input-error ion-padding"
          [hidden]="!(isForgotSubmitted && forgotForm.controls.email.errors?.['required'])"
        >
          {{ 'ERROR.REQUIRED' | transloco }}
        </span>
        <span
          class="input-error ion-padding"
          [hidden]="!(isForgotSubmitted && forgotForm.controls.email.errors?.['email'])"
        >
          {{ 'ERROR.EMAIL' | transloco }}
        </span>

        <div class="flex justify-center">
          <gt-button size="xl" (click)="resetPassword()">
            {{ 'ONBOARDING.FORGOT_PASSWORD.BUTTON.SEND' | transloco }}</gt-button
          >
        </div>
      </form>
    </div>
  </div>
</ion-content>
